import GraphTraversalDemo from "../assets/GraphTraversalDemo_AdobeExpress_OP.gif";
import ImageProcessingDemo from "../assets/ImageProcessingDemo_AdobeExpress_OP.gif";
import MineSweeperDemo from "../assets/MineSweeperDemo_AdobeExpress_OP.gif";
import NBodyDemo from "../assets/NBodyDemo_AdobeExpress_OP.gif";
import CompilerDemo from "../assets/PLCInterpreter_AdobeExpress.gif";
import DashboardDemo from "../assets/DashBaord.gif";
import raytraceDemo from "../assets/ray.gif";
import curveDemo from "../assets/cur.gif";
import shadingDemo from "../assets/sha.gif";
import transformDemo from "../assets/tra.gif";
import KernelPatchDemo from "../assets/KernelMod.gif";
import DataAnalyticsDemo from "../assets/data_analysis.gif";
import systemcallsDemo from "../assets/systemcalls.gif";

import GraphTraversalDemoV from "../assets/GraphTraversalDemo_AdobeExpress.mp4";
import ImageProcessingDemoV from "../assets/ImageProcessingDemo_AdobeExpress.mp4";
import MineSweeperDemoV from "../assets/MineSweeperDemo_AdobeExpress.mp4";
import NBodyDemoV from "../assets/NBodyDemo_AdobeExpress.mp4";
import CompilerDemoV from "../assets/PLCInterpreter_AdobeExpress.mp4";
import DashboardDemoV from "../assets/DashBaord.mp4";
import raytraceDemoV from "../assets/ray.mp4";
import curveDemoV from "../assets/cur.mp4";
import shadingDemoV from "../assets/sha.mp4";
import transformDemoV from "../assets/tra.mp4";
import KernelPatchDemoV from "../assets/Kernel Mod.mp4";
import DataAnalyticsDemoV from "../assets/data_analysis.mp4";
import systemcallsDemoV from "../assets/systemcalls.mp4";

export const ProjectList = [
  {
    name: "Kernel System Calls",
    image: systemcallsDemo,
    video: systemcallsDemoV,
    skills: "C++, Linux, Patchfiles, Libraries, Testing, Operating Systems, Virtualization, Git",
    description: "Implement a system call in Reptilian along with three static library functions that allow the system call to be invoked from a C API. These custom system calls will get and set a custom process log level that will sit atop the standard Linux kernel’s diagnostic message logging system (dmesg) and allow processes to submit log entries along with a log level."
  },
  {
    name: "E-Commerce Data Analytics",
    image: DataAnalyticsDemo,
    video: DataAnalyticsDemoV,
    skills: "Python, scikit-learn, pandas, numpy",
    description: "Analyzed customer data to uncover trends, segment users with clustering (K-Means, DBSCAN), and design personalized marketing strategies. Built classification and regression models to predict purchases and forecast sales, aiding conversion and seasonal discount planning. Applied association rule mining (Apriori) to identify frequent itemsets and create effective product bundling strategies."
  },
  {
    name: "Kernel Patch",
    image: KernelPatchDemo,
    video: KernelPatchDemoV,
    skills: "C++, Linux, Operating Systems, Virtualization, Git, Patchfiles",
    description: "rebuilt the kernel and saw that my custom boot message was applied successfully and created a patch that contained all the changes."
  },
  {
    name: "Recursive Raytracer",
    image: raytraceDemo,
    video: raytraceDemoV,
    skills: "C++, OpenGL, Data Structures, Algorithm Design, Image Order Processing, Physics",
    description: "Implemented advanced ray tracing techniques using OpenGL, demonstrating proficiency in real-time rendering and graphics programming. Recursive algorithms to achieve realistic lighting, shadows, and reflections in 3D scenes, showcasing strong problem-solving and mathematical skills. "
  },
  {
    name: "Model Transformations",
    image: transformDemo,
    video: transformDemoV,
    skills: "C++, OpenGL, GLSL, GLM, Data Structures, Algorithm Design, Graphics Pipeline, GPU Shaders, Parallel Processing",
    description: "Alogorithm to read obj files and create triangular face verticies to be read by the vertex and fragment shader in OpenGL. Supports affine transformations coded in GLM."
  },
  {
    name: "Model Shading",
    image: shadingDemo,
    video: shadingDemoV,
    skills: "C++, OpenGL, GLSL, GLM, Data Structures, Algorithm Design, Graphics Pipeline, GPU Shaders, Parallel Processing",
    description: "Added shading types to the model transformation to allow for Gouraud, Flat, and Phong Shading. Added linear depth buffer and FOV for perspective matrix."
  },
  {
    name: "Bezier Curve",
    image: curveDemo,
    video: curveDemoV,
    skills: "C, Algorithm Design, Graph Theory, Visualization, Problem Solving",
    description: "For this project, I designed a user interface so that the user can input several control points, then designed a Cubic C^1 Bezier curve from the control points in which I have to input enough control points to have at least two segments. Then drawing the curve using the blending functions or matrix form and de Castelijau’s algorithm."
  },
  {
    name: "Graph Depth/Breadth Visualizer",
    image: GraphTraversalDemo,
    video: GraphTraversalDemoV,
    skills: "C++, SFML Library, Data Structures, Algorithm Design, Graph Theory, Visualization, Problem Solving",
    description: "Developed a graph traversal visualizer using the SFML library. This tool provides a user-friendly interface for visualizing and interacting with depth and breadth-first search algorithms on large canvases with over 100,000 data points. The implementation optimally highlights pixel filling based on the selected algorithm."
  },
  {
    name: "Image Processing",
    image: ImageProcessingDemo,
    video: ImageProcessingDemoV,
    skills: "C++, Image Processing Algorithms, File Input/Output (TGA), Computer Vision Concepts",
    description: "Implemented an image processing application in C++ that allows users to perform various modifications on TGA images, including combining, separating, multiplying, and scaling. The project incorporates fundamental image processing algorithms and concepts from computer vision."
  },
  {
    name: "N Body Simulation",
    image: NBodyDemo,
    video: NBodyDemoV,
    skills: "C++, SFML Library, Physics Simulation, Numerical Methods, Object-Oriented Design",
    description: "Built an N-body simulation using C++ and the SFML library. The simulation represents gravitational attraction between multiple bodies and employs the Barnes-Hutt quadtree implementation for optimization. This project showcases proficiency in physics simulation, numerical methods, and object-oriented design."
  },
  {
    name: "MineSweeper Game",
    image: MineSweeperDemo,
    video: MineSweeperDemoV,
    skills: "C++, SFML Library, Game Development, UI/UX Design, Problem Solving",
    description: "Developed a Minesweeper game in C++ using the SFML library. The project includes a graphical user interface with an interactive game board. It demonstrates skills in game development, UI/UX design, and problem-solving by creating a clone of the classic Minesweeper game."
  },
  {
    name: "Code Interpreter",
    image: CompilerDemo,
    video: CompilerDemoV,
    skills: "Java, Lexical Analysis, Syntax Analysis, Semantic Analysis, Code Generation, Code Optimization, Error Handling, Software Engineering",
    description: "Implemented a code interpreter in Java that processes a custom language. The interpreter includes lexical analysis, syntax analysis, semantic analysis, and code generation. It builds an abstract syntax tree and executes code. This project showcases strong skills in compiler construction, error handling, and software engineering principles."
  },
  {
    name: "React Student Dashboard",
    image: DashboardDemo,
    video: DashboardDemoV,
    skills: "JavaScript, React, MERN Development, Strapi, Docker",
    description: "Developed a React-based student dashboard for MERN stack applications. The dashboard allows users to view, share, and edit lessons and projects. This project demonstrates proficiency in JavaScript, React, MERN development, and containerization using Docker."
  }
];
